/* unplugin-vue-components disabled */import { render } from "./交互.vue?vue&type=template&id=8b40d222&scoped=true"
import script from "./交互.vue?vue&type=script&lang=js"
export * from "./交互.vue?vue&type=script&lang=js"

import "./交互.vue?vue&type=style&index=0&id=8b40d222&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b40d222"]])

export default __exports__